import { FilterModal } from './components/Filter/Filter.js';
import { TableHeader } from './components/TableHeader/TableHeader.js';
import { SearchInput } from './components/SearchInput/SearchInput.js';
import { Table } from './components/Table/Table.js';
import { Container } from './styles.js';

const DataTable = {
    Container,
    Filter: FilterModal,
    SearchInput,
    Table,
    TableHeader,
};

export { DataTable };
